import { render, staticRenderFns } from "./searchlist4.vue?vue&type=template&id=0c4ffcf5&scoped=true"
import script from "./searchlist4.vue?vue&type=script&lang=js"
export * from "./searchlist4.vue?vue&type=script&lang=js"
import style0 from "./searchlist4.vue?vue&type=style&index=0&id=0c4ffcf5&prod&lang=less"
import style1 from "./searchlist4.vue?vue&type=style&index=1&id=0c4ffcf5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4ffcf5",
  null
  
)

export default component.exports